import { Component, OnInit } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { Router } from "@angular/router";
import { environment } from "../../../../../environments/environment";

@Component({
  selector: "app-student-userdata-list",
  templateUrl: "./student-userdata-list.component.html",
  styleUrls: ["./student-userdata-list.component.scss"],
})
export class StudentUserdataListComponent implements OnInit {
  public list = [];
  message = null;
  class = null;
  userRole = localStorage.getItem("userRole");

  constructor(private router: Router, private http: HttpClient) {}

  public settings = {
    actions: {
      position: "right",
      add: false,
      edit: false,
      delete: this.userRole == "super-admin" || this.userRole == "admin" ? true : false,
    },
    delete: {
      confirmDelete: true,
      deleteButtonContent: '<i class="fa fa-trash text-danger"></i>'
    },
    columns: {
      name: {
        title: "Name",
      },
      username: {
        title: "Username",
      },
      email: {
        title: "Email",
      },
      mobilenumber: {
        title: "Mobile No",
      },
      status: {
        title: "Status",
        valuePrepareFunction: (value) => {
          return value ? 'Active' : 'Inactive';
        }
      },
      _id: {
        title: "Actions",
        type: "html",
        valuePrepareFunction: (cell, row) => {
          let actions = '';
          
          // Edit button - show for all roles
          actions += `<a href="#/student-details/edit-student-userdata/${row._id}" class="btn btn-sm btn-primary me-1">
            <i class="fa fa-pencil"></i>
          </a>`;
          
          // Delete button - only show for super-admin and admin
          if (this.userRole == "super-admin" || this.userRole == "admin") {
            actions += `<button class="btn btn-sm btn-danger delete-btn" data-id="${row._id}">
              <i class="fa fa-trash"></i>
            </button>`;
          }
          
          return actions;
        },
        filter: false,
        sort: false,
        editable: false,
      },
    },
  };

  ngOnInit() {
    this.loadUserData();
    
    // Add event listener for delete buttons after view is initialized
    setTimeout(() => {
      this.addDeleteEventListeners();
    }, 1000);
  }

  loadUserData() {
    let role = this.userRole;
    let user = localStorage.getItem("userId");
    
    if (role == "admin" || role == "super-admin") {
      this.http
        .get<any>(`${environment.apiUrl}/userdata/`, {
          headers: this.getHeaders()
        })
        .subscribe(
          (data) => {
            if (data.message == "Logged Out!") {
              this.router.navigateByUrl("/auth/login");
              return;
            }
            
            if (data.results && Array.isArray(data.results)) {
              this.list = data.results;
            } else {
              console.error('Unexpected API response structure:', data);
              this.list = [];
            }
          },
          (err: HttpErrorResponse) => {
            this.handleError(err, "Error loading user data");
          }
        );
    } else {
      this.http
        .get<any>(`${environment.apiUrl}/userdata/${user}`, {
          headers: this.getHeaders()
        })
        .subscribe(
          (data) => {
            if (data.message == "Logged Out!") {
              this.router.navigateByUrl("/auth/login");
              return;
            }
            
            if (data.data) {
              this.list = [data.data];
            } else if (data.results) {
              this.list = data.results;
            } else {
              this.list = [];
            }
          },
          (err: HttpErrorResponse) => {
            this.handleError(err, "Error loading user data");
          }
        );
    }
  }

  addDeleteEventListeners() {
    // Add click event to custom delete buttons
    const deleteButtons = document.querySelectorAll('.delete-btn');
    deleteButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        const target = event.target as HTMLElement;
        const deleteButton = target.closest('.delete-btn');
        if (deleteButton) {
          const userId = deleteButton.getAttribute('data-id');
          if (userId) {
            this.confirmDelete(userId);
          }
        }
      });
    });
  }

  confirmDelete(userId: string) {
    if (confirm("Are you sure you want to delete this user?")) {
      this.deleteUser(userId);
    }
  }

  deleteUser(userId: string) {
    this.http
      .delete<any>(`${environment.apiUrl}/userdata/${userId}`, {
        headers: this.getHeaders()
      })
      .subscribe(
        (data) => {
          if (data.message == "Logged Out!") {
            this.router.navigateByUrl("/auth/login");
            return;
          }
          
          if (data.status == "500") {
            this.showMessage(data.message, "danger");
          } else {
            this.showMessage("Successfully Deleted", "success");
            this.loadUserData(); // Reload the data
          }
        },
        (err: HttpErrorResponse) => {
          this.handleError(err, "Error deleting user");
        }
      );
  }

  deleteRecord(event) {
    // This is for the built-in delete functionality of ng2-smart-table
    if (confirm("Are you sure you want to delete this user?")) {
      this.deleteUser(event.data._id);
    } else {
      event.confirm.reject();
    }
  }

  private getHeaders() {
    return {
      Userinfo: JSON.stringify({
        _id: localStorage.getItem("adminSess"),
        role: localStorage.getItem("userRole"),
      }),
    };
  }

  private showMessage(message: string, type: string) {
    this.message = message;
    this.class = type === "success" 
      ? "btn-success rounded px-1 py-1" 
      : "btn-danger rounded px-1 py-1";
    
    window.scrollTo(0, 0);
    setTimeout(() => {
      this.message = null;
    }, 3000);
  }

  private handleError(err: HttpErrorResponse, context: string) {
    console.error(context, err);
    this.showMessage("An error occurred. Please try again.", "danger");
    
    if (err.error instanceof Error) {
      console.log("Client-side error occurred.");
    } else {
      console.log("Server-side error occurred.");
    }
  }
}